
//table表格组件头部标题统一管理

const tables_title_en = {
  account:'account',
  name:'name',
  dept:'dept',
  role:'role',
  position:'position',
  phone:'phone',
  create_time:'create time',
  update_time:'update time',
  status:'status',
  assign_roles:'assign roles',
  reset_password:'reset password',
  dept_assign:'dept assign',
  birthday:'birthday',
  password:'password',
  repeat_password:'re-password',
  email:'e-mail',
  sex:'sex',
  male:'male',
  female:'female',
  wx:'WechatID',
  address: 'address',
  patientName: 'patientName',
  //roles
  superior_role:'superior role',
  alias:'alias',
  sort:'sort',
  //depts
  simple_name:'simple name',
  full_name:'full name',
  remarks:'remarks',
  superior_name:'superior name',
  //posts
  posts_name:'position name',
  posts_code:'position code',
  //dict type
  dict_type:'dictionary type',
  sys_type:'system type',
  non_sys_type:'Non system type',
  enable:'ENABLE',
  disable:'DISABLE',
  type_name:'type name',
  type_code:'type code',
  sys_dict:'system dictionary',
  dict_desc:'dict description',
  yes:'Y',
  no:'N',
  dict_name:'dictionary name',
  dict_code:'dictionary code',
  super_dict:'super dict',
  //menus
  level:'level',
  menu:'menu',
  menu_name:'menu name',
  menu_code:'menu code',
  parent_num:'parent number',
  req_addr:'request address',

  //login_log
  log_name:'log name',
  user_name:'user name',

  log_type:'log type',
  log_class:'class',
  log_method:'method',
  exception_log:'exception log',
  business_log:'business log',

  //messages
  title:'title',
  content:'content',
  creater_name:'creater name',

  //tenant
  tenant_name:'tenant name',
  tenant_code:'tenant code',
  update_name:'updater name',
  database_name:'database name',

  scale_name: 'Name of scale',
  model_name: 'The model name',
  report_name: 'Report name',
  model_issue_state: 'publish status',
  evaluation_name:'Evaluation name',
  evaluation_time:'Evaluation time',

  identity_ard: 'identity card',
  index_name: 'index name',

  mobile_phone_number: 'cell phone number',
  var_name: 'variable name',
  relevance_topic_or_index: 'Associate topics/indicators',
  relevance_topic_type: 'Associated topic type',
  common_model: 'Commonly used models',
  project_name: 'project name',
  project_id: 'The project id',
  tag: 'label',
  questionnaire_list:'Questionnaire list',
  color:'Color',
  submitNumber: 'Times of filling',

  label_type_name: "Label type name"
}

export default tables_title_en



// WEBPACK FOOTER //
// ./src/common/lang/tables_title/tables_title_en.js